import React from 'react';
import { LinearProgress } from '@mui/material';
import If from '@components/if/if.tsx';
import ChartLoader from '@shared/components/charts/chart-loader/chart-loader.tsx';
import ChartEmpty from '@shared/components/charts/chart-empty/chart-empty.tsx';
import {
  ProgressListProps,
  ProgressListItem
} from '@shared/models/charts/progress-list.model.ts';

const ProgressList: React.FC<ProgressListProps> = ({
  data,
  loading = false,
  height = 300,
  progressColor = 'var(--teal)',
  trackColor = 'var(--gray-alpha-500)'
}) => {
  return (
    <div className="bg-(--white) rounded-xl p-4 overflow-hidden relative shadow-[0_4px_12px_rgba(0,0,0,0.05)]">
      <If
        loading={loading}
        condition={!loading && data.length > 0}
        loadingContent={<ChartLoader height={height} />}
        emptyContent={<ChartEmpty height={height} />}
      >
        <div
          className="flex flex-col gap-4 overflow-y-auto"
          style={{ height: height }}
        >
          {data.map((item: ProgressListItem, index: number) => (
            <div
              key={index}
              className="flex items-center h-15.75 gap-4 rounded-[10px] bg-(--gray-11) px-4 shrink-0"
            >
              <div className="shrink-0 size-6">{item.icon}</div>

              <div className="flex flex-1 flex-col gap-2">
                <div className="flex items-center justify-between">
                  <span className="text-[16px] font-normal text-(--blue-4)">
                    {item.name}
                  </span>
                  <span className="text-[16px] font-normal text-(--blue-4)">
                    {item.percent}%
                  </span>
                </div>

                <LinearProgress
                  variant="determinate"
                  value={Math.min(Math.max(item.percent, 0), 100)}
                  sx={{
                    height: 8,
                    borderRadius: 9999,
                    backgroundColor: trackColor,
                    '& .MuiLinearProgress-bar': {
                      borderRadius: 9999,
                      backgroundColor: progressColor
                    }
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </If>
    </div>
  );
};

export default ProgressList;
